"use strict";
var simple_notifications_module_1 = require('./src/simple-notifications.module');
exports.SimpleNotificationsModule = simple_notifications_module_1.SimpleNotificationsModule;
var simple_notifications_component_1 = require('./src/simple-notifications.component');
exports.SimpleNotificationsComponent = simple_notifications_component_1.SimpleNotificationsComponent;
var notification_component_1 = require('./src/notification.component');
exports.NotificationComponent = notification_component_1.NotificationComponent;
var notifications_service_1 = require('./src/notifications.service');
exports.NotificationsService = notifications_service_1.NotificationsService;
var max_pipe_1 = require('./src/max.pipe');
exports.MaxPipe = max_pipe_1.MaxPipe;
var push_notifications_module_1 = require('./src/push-notifications.module');
exports.PushNotificationsModule = push_notifications_module_1.PushNotificationsModule;
var push_notifications_service_1 = require('./src/push-notifications.service');
exports.PushNotificationsService = push_notifications_service_1.PushNotificationsService;
//# sourceMappingURL=components.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular2-notifications/components.js
// module id = 302
// module chunks = 3